<template>
    <div class="c-ratings-box">
        <div class="c-ratings-box__filter" v-if="filteredStars != 'all'">
            <div class="c-ratings-filter">
                <div class="c-ratings-filter__title">
                    {{ $t("Ratings.Filter.title") }}
                </div>

                <div class="c-ratings-filter__item" v-if="false">
                    <button
                        type="button"
                        class="c-btn"
                        :class="{ 'is-active': filteredLocale == 'all' }"
                        @click="setLocaleFilter('all')"
                    >
                        <div class="sc-circle"></div>
                        <div class="sc-text">{{ $t("Ratings.General.all") }}</div>
                    </button>
                </div>

                <div class="c-ratings-filter__item" v-if="false">
                    <button
                        type="button"
                        class="c-btn"
                        :class="{ 'is-active': filteredLocale == locale }"
                        @click="setLocaleFilter(locale)"
                    >
                        <div class="sc-circle"></div>
                        <div class="sc-text">{{ $t(`Ratings.Only.${locale}`) }}</div>
                    </button>
                </div>

                <div class="c-ratings-filter__item" @click="setStarsFilter('all')">
                    <div class="sc-key">
                        {{ $t("Ratings.Filter.stars") }}
                    </div>

                    <div class="sc-value">
                        {{ filteredStars }}
                    </div>

                    <i class="ico ico-cross"></i>
                </div>

                <div class="c-ratings-filter__item is-reset" @click="setStarsFilter('all')">
                    <i class="ico ico-cross"></i>

                    <div class="sc-value">
                        {{ $t("Ratings.Filter.reset") }}
                    </div>
                </div>
            </div>
        </div>

        <div class="c-ratings-box__list" :class="{ 'has-limit': showMore }">
            <div
                class="c-ratings-box__item"
                v-for="rating in limitedFilteredRatings"
                :key="rating.id"
            >
                <div class="sc-header">
                    <div class="sc-header__name">
                        {{ makeInitials(rating.customer_name) }}

                        <div class="c-stars">
                            <div class="c-stars__empty">
                                <i class="ico ico-star-full" aria-hidden="true"></i>
                                <i class="ico ico-star-full" aria-hidden="true"></i>
                                <i class="ico ico-star-full" aria-hidden="true"></i>
                                <i class="ico ico-star-full" aria-hidden="true"></i>
                                <i class="ico ico-star-full" aria-hidden="true"></i>
                            </div>

                            <div class="c-stars__full" :style="`width: ${rating.rating}%;`">
                                <i class="ico ico-star-full" aria-hidden="true"></i>
                                <i class="ico ico-star-full" aria-hidden="true"></i>
                                <i class="ico ico-star-full" aria-hidden="true"></i>
                                <i class="ico ico-star-full" aria-hidden="true"></i>
                                <i class="ico ico-star-full" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>

                    <div class="sc-header__date">
                        {{ formatDate(rating.created) }}
                    </div>
                </div>

                <div class="sc-description" v-if="rating.description">
                    {{ rating.description }}
                </div>

                <div class="sc-list" v-if="rating.pros || rating.cons">
                    <div class="sc-list__column" v-if="rating.pros">
                        <div
                            class="sc-list__item"
                            v-for="(pro, index) in rating.pros.split('\n')"
                            :key="index"
                        >
                            <i class="ico ico-plus-circle"></i>
                            <span class="sc-text">{{ pro }}</span>
                        </div>
                    </div>

                    <div class="sc-list__column" v-if="rating.cons">
                        <div
                            class="sc-list__item"
                            v-for="(con, index) in rating.cons.split('\n')"
                            :key="index"
                        >
                            <i class="ico ico-minus-circle"></i>
                            <span class="sc-text">{{ con }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="c-ratings-box__more" v-if="showMore">
            <button
                type="button"
                :title="$t('Ratings.General.more')"
                class="c-btn c-btn--secondary"
                @click.prevent="moreRatings = true"
            >
                <span class="sc-text">{{ $t("Ratings.General.more") }}</span>
                <i class="ico ico-chevron-down" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</template>

<script>
import client from "./../../../../vendor/rshop/frontend/assets/js/common/client";
import { CancelToken } from "axios";

export default {
    data() {
        return {
            isInitialized: false,
            fetchCancelToken: null,
            fetchingRatings: true,
            ratings: [],
            ratingsLimit: 6,
            locales: [],
            productId: document.querySelector(".js-product-detail").getAttribute("data-product-id"),
            filteredLocale: Eshop.options.locale,
            filteredStars: "all",
            locale: Eshop.options.locale,
            moreRatings: false,
        };
    },
    created() {
        this.fetchRatingsBox();

        rEvent.on("Rating.triggerFilter", (starsNumber, ratingsCount) => {
            if (ratingsCount > 0) {
                this.setStarsFilter(starsNumber);
            }
        });
    },
    methods: {
        cancelFetchRatingsBox() {
            if (this.fetchCancelToken) {
                this.fetchCancelToken.cancel();
            }

            this.fetchCancelToken = CancelToken.source();
        },
        fetchRatingsBox() {
            this.cancelFetchRatingsBox();
            this.fetchRatings();
        },
        fetchRatings() {
            this.fetchingRatings = true;

            client
                .get(`/fetch-ratings/${this.productId}`, {
                    cancelToken: this.fetchCancelToken.token,
                })
                .then((response) => {
                    if (!response.data.status) {
                        return;
                    }

                    this.ratings = Object.values(response.data.data.ratings);
                    this.locales = Object.values(response.data.data.locales);
                    this.isInitialized = true;
                })
                .catch((error) => {})
                .then(() => {
                    this.fetchingRatings = false;
                });
        },
        setLocaleFilter(locale) {
            this.filteredLocale = locale;
            this.moreRatings = false;
        },
        setStarsFilter(starsNumber) {
            this.filteredStars = starsNumber;
            this.moreRatings = false;
        },
        formatDate(date) {
            const d = new Date(date);

            return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;
        },
        makeInitials(name) {
            const words = name.split(" ");

            // Check if there are any words to process.
            if (words.length === 0) {
                return "";
            }

            // Keep the first word (first name) as is.
            const firstName = words[0];

            // Map through the rest of the words to convert them into initials, if any.
            const initials = words.slice(1).map((word) => {
                if (word.length > 0) {
                    return word[0].toUpperCase() + ".";
                }

                return "";
            });

            // Combine the full first name with the initials of the rest of the names.
            return [firstName, ...initials].join(" ");
        },
    },
    computed: {
        filteredRatings() {
            return this.ratings.filter((rating) => {
                const localeResult =
                    rating.locale == this.filteredLocale || this.filteredLocale == "all";
                const starsResult =
                    Math.ceil(rating.rating / 20) == this.filteredStars ||
                    this.filteredStars == "all";

                return localeResult && starsResult;
            });
        },
        limitedFilteredRatings() {
            return this.filteredRatings.length > this.ratingsLimit && !this.moreRatings
                ? this.filteredRatings.slice(0, this.ratingsLimit)
                : this.filteredRatings;
        },
        showMore() {
            return this.filteredRatings.length > this.ratingsLimit && !this.moreRatings;
        },
    },
};
</script>
